import { normalizeAvisoPhone } from '@conversia/shared-types';

/**
 * Alta manual de cliente (Fase 1 trabajo manual): validación PURA del
 * formulario nombre + teléfono. Espejo de las reglas del backend
 * (`createManualContact` exige código de país vía normalizeAvisoPhone).
 */

/** Solo los dígitos del teléfono (lo que el backend usa como identidad). */
export function phoneDigits(telefono: string): string {
  return telefono.replace(/\D/g, '');
}

export type ManualClientValidation = { ok: true } | { ok: false; error: string };

export function validateManualClient(input: {
  nombre: string;
  telefono: string;
}): ManualClientValidation {
  if (!input.nombre.trim()) return { ok: false, error: 'El nombre es obligatorio' };
  // Código de país obligatorio (el bug de los avisos al vacío): RD de 10
  // dígitos se corrige solo; lo irrecuperable se rechaza con mensaje claro.
  const normalized = normalizeAvisoPhone(input.telefono);
  if (!normalized.ok) return { ok: false, error: normalized.error };
  return { ok: true };
}
